import * as React from "react";
import { SettingType, SettingValueType } from "../misc/api/apiTypes";
import { TextBox } from "../forms/informedv2/TextBox";
import { PrimitiveMultiSelect } from "../forms/informedv2/MultiSelect";
import { Checkbox } from "../forms/informedv2/Checkbox";
import { TimePicker } from "../forms/informedv2/TimePicker";
import { Tags } from "../forms/informedv2/Tags";
import { useArrayField, useFieldApi } from "informed";
import './settings-control-renderer.css';
import { Required } from "../forms/validation/Required";

export const RenderSettingControl = ({ settingDefinition, settingKey, parentSectionKey }) => {
    if (settingDefinition.editable == false)
        return null;

    const required = settingDefinition.required !== null && settingDefinition.required !== undefined
        ? settingDefinition.required
        : undefined;

    const controlPath = `${parentSectionKey}.${settingKey}`;

    var field = useFieldApi(controlPath);
    var fieldValue = field.getValue() as any;

    var valueChanged = false;

    if (Array.isArray(settingDefinition.defaultValue)) {
        if (fieldValue == undefined) {
            valueChanged = settingDefinition.defaultValue.length !== 0;
        }
        else {
            valueChanged = (settingDefinition.defaultValue.length != fieldValue?.length) ||
                !settingDefinition.defaultValue.every((value, index) => value == fieldValue[index])
        }
    } else {
        valueChanged = settingDefinition.defaultValue != fieldValue
    }

    if (settingDefinition.selectable) {
        return (
            <div className="form-group col-md-6 col-sm-6 col-xs-12 setting-input">
                <label htmlFor={controlPath}>
                    {settingDefinition.label}
                    {
                        valueChanged ? <i className="fas fa-pen" data-bs-toggle="tooltip" title="Setting Changed" /> :
                            null
                    }
                </label>
                <p className="help-block">{settingDefinition.helpText}</p>
                <PrimitiveMultiSelect
                    id={controlPath}
                    field={controlPath}
                    options={settingDefinition.datasource}
                    labelKey="text"
                    valueKey="value"
                    allowSelectAll={settingDefinition.valueType == SettingValueType.Collection}
                    multi={settingDefinition.valueType == SettingValueType.Collection}
                    validate={value => (required !== false ? Required(value) : undefined)}
                />
            </div>
        )
    }

    switch (settingDefinition.type) {
        case SettingType.String:
            if (settingDefinition.valueType === SettingValueType.Collection) {
                return (
                    <div className="form-group col-md-6 col-sm-6 col-xs-12 setting-input">
                        <label htmlFor={controlPath}>
                            {settingDefinition.label}
                            {
                                valueChanged ? <i className="fas fa-pen" data-bs-toggle="tooltip" title="Setting Changed" /> :
                                    null
                            }
                        </label>
                        <p className="help-block">{settingDefinition.helpText}</p>
                        <Tags field={controlPath} />
                    </div>
                )
            }
            if (settingDefinition.valueType === SettingValueType.One) {
                return (
                    <div className="form-group col-md-6 col-sm-6 col-xs-12 setting-input largen-height">
                        <label htmlFor={controlPath}>
                            {settingDefinition.label}
                            {
                                valueChanged ? <i className="fas fa-pen" data-bs-toggle="tooltip" title="Setting Changed" /> :
                                    null
                            }
                        </label>
                        <p className="help-block">{settingDefinition.helpText}</p>
                        <TextBox id={controlPath} field={controlPath} allowEmptyString={true} required={required === true} />
                    </div>
                )
            }
        case SettingType.Boolean:
            return (

                <div className="form-group col-md-6 col-sm-6 col-xs-12 setting-input largen-height">
                    <Checkbox id={controlPath} field={controlPath} label={settingDefinition.label} labelSuffix={() => valueChanged ? <i className="fas fa-pen" data-bs-toggle="tooltip" title="Setting Changed" /> :
                        null} />
                    <p className="help-block">{settingDefinition.helpText}</p>
                </div>
            )
        case SettingType.Number:
            return (
                <div className="form-group col-md-6 col-sm-6 col-xs-12 setting-input largen-height">
                    <label htmlFor={controlPath}>
                        {settingDefinition.label}
                        {
                            valueChanged ? <i className="fas fa-pen" data-bs-toggle="tooltip" title="Setting Changed" /> :
                                null
                        }
                    </label>
                    <p className="help-block">{settingDefinition.helpText}</p>
                    <TextBox type="number" id={controlPath} field={controlPath} allowEmptyString={required !== false} required={required !== false} />
                </div>
            )
        case SettingType.Time:
            if (settingDefinition.valueType === SettingValueType.Collection) {
                const arrayFields = useArrayField({ field: controlPath, });
                return (
                    <>
                        {arrayFields.fields.map(({ field, key, remove }, i) => (
                            <div className="form-group col-md-6 col-sm-6 col-xs-12 setting-input largen-height" key={key}>
                                <label htmlFor={field}>
                                    {settingDefinition.label}
                                </label>
                                <TimePicker
                                    key={key}
                                    id={field}
                                    field={field}
                                    label=""
                                    placeholderText="HH:mm (24 hour format)"
                                    dateFormat="HH:mm:ss"
                                    required={required !== false}
                                    suffix={<i className="text-danger fas fa-times" onClick={() => remove && remove()} style={{ cursor: 'pointer' }} />}
                                />
                            </div>
                        ))}
                        <div className="col-md-12">
                            <button className="btn btn-primary btn-outline" type="button" onClick={() => arrayFields.add()}>Add {settingDefinition.label}</button>
                        </div>
                    </>
                )
            }
            if (settingDefinition.valueType === SettingValueType.One) {
                return (
                    <div className="form-group col-md-6 col-sm-6 col-xs-12 setting-input largen-height">
                        <label htmlFor={controlPath}>
                            {settingDefinition.label}
                            {
                                valueChanged ? <i className="fas fa-pen" data-bs-toggle="tooltip" title="Setting Changed" /> :
                                    null
                            }
                        </label>
                        <TimePicker
                            key={controlPath}
                            id={controlPath}
                            field={controlPath}
                            label=""
                            placeholderText="HH:mm (24 hour format)"
                            dateFormat="HH:mm"
                            required={required !== false}
                        />
                    </div>
                )
            }
        default:
            return null;
    }
}
